import sortBy from 'lodash.sortby'

export default function getUsedDiscountLv(items, totalOrderAmountWithCoupon) {
  return sortBy(items, item => item.amount)
    .slice()
    .reverse()
    .find(item => totalOrderAmountWithCoupon >= item.amount)
}
